import React from 'react'
import { IconButton, Typography } from '@mui/material'
import Link from 'next/link'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { RowCenterY } from '@/components/common/Rows'
import TokenLogo, { BtcLogo } from '@/components/common/TokenLogo'
import { getOklinkPageUrl, shortenAddress, shortenBtcAddress } from '@/utils/address'
import { CHAIN_INFO } from '@/constants'

const AddressCell = ({ chainId, address, txId }: { chainId: number; address: string; txId: string }) => {
  const isChainUnknown = chainId === -1
  const isOnBtc = chainId === 0

  if (isChainUnknown) {
    return '--'
  }

  if (isOnBtc) {
    return (
      <RowCenterY sx={{ columnGap: 4 }}>
        <BtcLogo size={20} />

        <Link href={getOklinkPageUrl(address, 'address')} target="_blank">
          <Typography sx={{ fontSize: '16px', fontWeight: 500, textDecorationLine: 'underline' }}>
            {shortenBtcAddress(address)}
          </Typography>
        </Link>

        {txId && (
          <Link href={getOklinkPageUrl(txId, 'tx')} target="_blank">
            <IconButton size="small">
              <OpenInNewIcon sx={{ width: 20, height: 20 }} />
            </IconButton>
          </Link>
        )}
      </RowCenterY>
    )
  }

  return (
    <RowCenterY sx={{ columnGap: 4 }}>
      <TokenLogo size={20} src={CHAIN_INFO?.[chainId].logoSrc} alt={CHAIN_INFO?.[chainId].name} />

      <Link href={`${CHAIN_INFO?.[chainId].blockExplorers.default.url}/address/${address}`} target="_blank">
        <Typography sx={{ fontSize: '16px', fontWeight: 500, textDecorationLine: 'underline' }}>
          {shortenAddress(address)}
        </Typography>
      </Link>

      {txId && (
        <Link href={`${CHAIN_INFO?.[chainId].blockExplorers.default.url}/tx/${txId}`} target="_blank">
          <IconButton size="small">
            <OpenInNewIcon sx={{ width: 20, height: 20 }} />
          </IconButton>
        </Link>
      )}
    </RowCenterY>
  )
}

export default AddressCell
